module.exports = __webpack_public_path__ + "ProximaNova-Bold.f9ac1c319253.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/ProximaNova-Bold.woff
// module id = ./src/styles/fonts/ProximaNova-Bold.woff
// module chunks = 21